import { toTitleCase } from "../components/MainContent/Dashboard/Charts/utils";
import moment from "moment";

export const formatCompetitorsData = (chartType, response, args) => {
    const { filter, postOrder, postOrderBy } = args;

    switch (chartType) {
        case "compRecentPosts": {
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            let obj = {};
            response.forEach((element, idx) => {
                const dt = element.data?.hits?.hits?.filter((item) => item?._source?.post?.post_subtype !== "ads");
                let recentPosts = [];
                dt?.forEach((item) => {
                    if (item) {
                        let image_url =
                            "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
                        let profile_pic =
                            "https://2020assets.s3.amazonaws.com/images/" +
                            item?._source?.post_author?.media[0].folder +
                            "/" +
                            item?._source?.post_author?.media[0].name;
                        let totalEngagement = item?._source.post?.engagement_values?.like_count + item?._source.post?.engagement_values?.comment_count;
                        // + item?._source.post?.engagement_values?.share_count +
                        // item?._source.post?.engagement_values?.view_count;
                        recentPosts.push({
                            gender: item?._source?.post_author?.gender,
                            profile_pic: profile_pic,
                            username: item?._source?.handlers[0].value,
                            post_type: item?._source?.post?.media[0].type,
                            image_url: image_url,
                            content: item?._source?.post?.content,
                            title: item?._source?.post?.title,
                            post_url: item?._source?.post?.url,
                            created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                            hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                            engagement: item?._source?.post?.engagement_values,
                            totalEngagement: totalEngagement,
                            platform: item?._source?.platforms[0].short_name,
                            impact: item?._source.impact_value,
                            post_subtype: item?._source.post.post_subtype,
                        });
                    }
                });
                // recentPosts = recentPosts.filter((item) => !item?.post_url?.includes("stories"));
                recentPosts = recentPosts.slice(0, 10);
                let query_id = element.obj.research_query_id;

                obj[query_id] = {
                    research_query_id: query_id,
                    posts: recentPosts,
                    name: element.obj?.name,
                    userName: element.obj?.userName,
                    platform: element.obj?.platform,
                };
            });

            return obj;
        }

        case "compPostCount": {
            // let dataObj = {
            //     nodata: false,
            //     totalPostCount: 0,
            // };
            // let totalpost = 0;

            // let finalData = [];
            // response.forEach((element, idx) => {
            //     let obj = {
            //         name: "",
            //         data: [],
            //     };

            //     let obj2 = { name: "", y: 0 };

            //     obj.name = obj2.name = `${element.obj?.userName} (${toTitleCase(element.obj?.platform)})`;
            //     obj2.y = element.data?.hits?.total || 0;

            //     totalpost += element.data?.hits?.total || 0;

            //     obj.data.push(obj2);
            //     // console.log("datat 111", obj);
            //     finalData.push(obj);
            // });
            // if (totalpost === 0) dataObj.nodata = true;
            // dataObj.totalPostCount = totalpost;
            // dataObj.data = finalData;
            // // console.log("datat n34543", dataObj, finalData);
            // return dataObj;

            let dataObj = {
                nodata: false,
                totalPostCount: 0,
                data: [],
            };

            let totalPost = 0;

            response.forEach((element) => {
                let name = `${element.obj?.userName} (${toTitleCase(element.obj?.platform)})`;
                let y = element.data?.hits?.total || 0;
                let obj = {
                    name,
                    data: [{ name, y }],
                };

                totalPost += y;

                dataObj.data.push(obj);
            });

            dataObj.nodata = totalPost === 0;
            dataObj.totalPostCount = totalPost;

            return dataObj;
        }

        case "compImpactScore": {
            let dataObj = {
                nodata: false,
                totalImpactScore: 0,
                data: [],
            };

            let totalImpact = 0;

            response.forEach((element) => {
                let name = `${element.obj?.userName} (${toTitleCase(element.obj?.platform)})`;
                let y = element.data?.aggregations?.total_impact_value?.value || 0;

                let obj = {
                    name,
                    data: [{ name, y }],
                };

                totalImpact += y;

                dataObj.data.push(obj);
            });

            dataObj.nodata = totalImpact === 0;
            dataObj.totalImpactScore = totalImpact;

            return dataObj;
        }
        case "compByHashtags": {
            // console.log("response response", response);
            let dataObj = {
                nodata: false,
                totalHashtags: 0,
                data: [],
            };
            let hashtags = 0;

            response.forEach((element) => {
                let name = `${element.obj?.userName} (${toTitleCase(element.obj?.platform)})`;
                let obj = {
                    name,
                    // data: [{ name, y }],
                    data: [],
                };
                // let y = element.data?.aggregations?.total_impact_value?.value || 0;
                element.data?.aggregations?.by_hashtags?.buckets?.forEach((hashObj, idx) => {
                    if (idx < 5) {
                        let individualData = {};
                        individualData.name = hashObj.key;
                        individualData.y = hashObj.doc_count || 0;
                        hashtags += individualData.y;

                        obj.data.push(individualData);
                    }
                });

                dataObj.data.push(obj);
            });

            dataObj.nodata = hashtags === 0;
            dataObj.totalHashtags = hashtags;

            return dataObj;
        }
        default:
            return response;
    }
};
